export const monthFrequency = (frequencies) => {
  const ids = frequencies.map(e => e.id);
  const filteredIds = ids.filter(e => e.startsWith('m'));
  if (filteredIds.length > 0) {
    return filteredIds[0];
  } else {
    return ids[0];
  }
};
